import React, { useState, useContext, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';

import { Container, Card, Button, Form , Col, Row,Spinner } from 'react-bootstrap';
import home from '../../../images/home.png'
import AppContext from '../../../AppContext';
import {FaArrowRight} from 'react-icons/fa'
import masterCard from '../../../images/master-card.svg'
import visa from '../../../images/visa.svg'
import discover from '../../../images/discover.svg'
import car from '../../../images/car.png'
import PaymentModal from '../Booking/Flights/PaymentModal';
import CarPaymentModal from './CarPayment';

const CarItinerary = () =>{
  const [modalShow, setModalShow] = useState(false);

  
 
  const handleModalShow = (e) => {

   e.preventDefault()
    setModalShow(true);
    
  } 
  const [email,setEmail] =useState('');
 
  const [isFormValid, setIsFormValid] = useState(false);
  const [isForm2Valid, setIsForm2Valid] = useState(false);
  const [isForm3Valid, setIsForm3Valid] = useState(false);
 const [title,setTitle] = useState('')
 const [firstName,setFirstName] = useState('')
 const [lastName,setLastName] = useState('')

 const [phoneNumber,setPhoneNumber] = useState('');
 
 const [cardDetails, setCardDetails] = useState('')
 const [expiryDate, setExpiryDate] = useState('')
 const [cvvNumber, setCvvNumber] = useState('')
 const [coupon, setCoupon] = useState('')
 const [cardName, setCardName] = useState('')
 const [nationality, setNationality] = useState('')

 const handleEmailChange= (e)=> {
  setEmail(e.target.value);
  validateForm()
 }

 const validateForm = () => {
  setIsFormValid(email !== ''  );
};

const validateForm2 = () => {
  setIsForm2Valid(firstName !== '' && lastName !== ''&& phoneNumber !== ''  && nationality !== '' && title !== ''  );
};
const validateForm3 = () => {
  setIsForm3Valid(cardName !== '' && cardDetails !== '' && cvvNumber !== '' && expiryDate !== '' );
};

const handleCvvNumberChange= (e)=> {
  setCvvNumber(e.target.value);
  validateForm3()
 }
 const handleCardNameChange= (e)=> {
  setCardName(e.target.value);
  validateForm3()
 }

 const handleCardDetailsChange= (e)=> {
  setCardDetails(e.target.value);
  validateForm3()
 }



 const handleExpiryDateChange= (e)=> {
  setExpiryDate(e.target.value);
  validateForm3()
 }



 const handleNationalityChange= (e)=> {
  setNationality(e.target.value);
  validateForm2()
 }

 const handleTitleChange= (e)=> {
  setTitle(e.target.value);
  validateForm2()
 }

const handlePhoneNumberChange= (e)=> {
  setPhoneNumber(e.target.value);
  validateForm2()
 }

 const handleCouponChange= (e)=> {
  setCoupon(e.target.value);
  
 }

const handleFirstNameChange= (e)=> {
  setFirstName(e.target.value);
  validateForm2()
 }

 const handleLastNameChange= (e)=> {
  setLastName(e.target.value);
  validateForm2()
 }


  const { carsId } = useParams();
  
  const [selectedCar, setSelectedCar] = useState(null);
  const { carsData, selectedCarType,
    selectedCarClass,
    selectedCarLocation,
    selectedPickUpTime,
    selectedPickUpDate,
    selectedDaysNo
    
     } = useContext(AppContext);
     const [selectedButton, setSelectedButton] = useState(0);
     const handleButtonClick = (buttonIndex) => {
       
      setSelectedButton(buttonIndex);
    };
     const formatDateToWords = (date) => {
      const options = {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      };
      return date.toLocaleDateString(undefined, options);
    };

  useEffect(() => {
   if (carsData) {
     const cars = carsData.find((cars) => cars.id === parseInt(carsId));
     setSelectedCar(cars);
   }
 }, [carsId, carsData]);

  if (!selectedCar) {
    return <div className='justify-content-center align-items-center text-center my-5'>
    <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        </div>;
  }
 const {carBrand, icon, amount} = selectedCar;
 const vatAmount = 5000;
 const totalAmount= amount + vatAmount;

  return (
    <Container fluid>
         <div className='p-md-5 mt-lg-5'>
         <div className='d-block d-md-flex px-sm-5 py-4 bg-white '>
            <button className={selectedButton === 0 ? 'active-itinerary itinerary-button' : 'itinerary-button'} onClick={() => handleButtonClick(0)}>
              <div>
                <p>Step 1</p>
                <h6>Booking details</h6>
              </div>
              </button>
              <button className={selectedButton === 1? 'active-itinerary itinerary-button' : 'itinerary-button'} >
              <div>
                <p>Step 2</p>
                <h6>Contact details</h6>
              </div>
              </button>
              <button className={selectedButton === 2 ? 'active-itinerary itinerary-button' : 'itinerary-button'} >
              <div>
                <p>Step 3</p>
                <h6>Passenger details</h6>
              </div>
              </button>
              <button className={selectedButton === 3 ? 'active-itinerary itinerary-button' : 'itinerary-button'} >
              <div>
                <p>Step 4</p>
                <h6>Payment</h6>
              </div>
              </button>
              
            </div>
            <div className='p-4' style={{fontFamily:'Lora'}}>
              {selectedButton === 0 &&(
                <div>
                  <div className='d-flex align-items-center gap-2'>
                  <img src={car} alt='car' style={{ width:'30px', height:'30px'}}className='mb-3'/>
                  <div style={{color:'#626F6F', fontSize:'16px', fontWeight:'500'}}>
                    <p>Car details</p>
                    
                  </div>
                  </div>
                  <Row  className='mt-3 gap-5' style={{color:'#283333'}}>
                  <Col xs={12} md={6}  style={{border:'1px solid #99A1A1'}}>
                  <div className='d-flex flex-column gap-3 p-3'>
                  <div className='d-flex align-items-center gap-2'>
                  <img src={icon}alt='carBrand-image'style={{ width:'60px', height:'60px'}}className='mb-3'/>
                  <div className='gap-0'>
                    <p style={{ fontSize:'16px', fontWeight:'700'}}>{carBrand}</p>
                    
                  </div>
                  </div>
                   <p style= {{ fontSize:'16px', fontWeight:'700'}}>Details</p>
                   <div>
                    <div style= {{ fontSize:'14px'}}>
                      <p><b> Pick-up Date: &nbsp; {formatDateToWords(selectedPickUpDate)} </b></p>
                      <p style={{color:' #818B8B'}}>Pick-up Time: &nbsp;{selectedPickUpTime}</p>
                      
                    </div>
                    <div style= {{ fontSize:'14px'}}>
                      <p><b>{selectedCarClass}</b></p>
                      <p style={{color:' #818B8B'}}>{selectedCarType}</p>
                      <p >{selectedCarLocation}, Nigeria</p>
                    </div>
                   </div>
                   <div className='text-center'>
                    <button onClick={() => handleButtonClick(1)} style={{height: '48px',
width: '200px',

borderRadius: '8px',

backgroundColor: '#008080', border:'none', color:'#fff'}}>Proceed</button>
                   </div>
                  </div>
                  </Col>
                  <Col className='' >
                  <div style={{border:'1px solid #99A1A1'}}>
                  <div className='p-3 d-flex flex-column gap-2' style= {{ fontSize:'16px', fontWeight:'600'}}>
                   <p style={{fontSize:'16px', fontWeight:'500'}}>Payment Details</p>
                   <div className='d-flex justify-content-between p-0 p-lg-1' style={{border:'1px solid #99A1A1'}}>
                    <p>{carBrand}</p>
                    <p>NGN {amount.toLocaleString()}</p>
                   </div>
                   
                   <div className='d-flex justify-content-between'>
                    <p>VAT</p>
                    <p>NGN {vatAmount.toLocaleString()}</p>
                   </div>
                   <div className='line' style={{width:'100%'}}></div>
                   <div className='d-flex justify-content-between'>
                    <p>Total</p>
                    <p style={{fontSize:"16px"}}>NGN {totalAmount.toLocaleString()}</p>
                   </div>
                  </div>
                  </div>
                  </Col>
                  </Row>
                </div>
              )}
               {selectedButton === 1 &&(
                <div>
                    <Row  className='mt-3 gap-5' style={{color:'#283333'}}>
                  <Col xs={12} md={6}  style={{border:'1px solid #99A1A1'}}>
                  <div className='d-flex flex-column gap-3 p-3'>
                    <Form onSubmit={() => handleButtonClick(2)}>
                      <Form.Group className='mb-4'>
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" placeholder="" value={email} onChange={handleEmailChange}
           isValid={email !== ''}
          isInvalid={email === ''}/>
        <Form.Text className="text-muted">
         Your mail is needed for booking confirmation
        </Form.Text>
                      </Form.Group>
                    
                   <div className='text-center'>
                    <button disabled={!isFormValid}  style={{height: '48px',
width: '200px',

borderRadius: '8px',

backgroundColor: '#008080', border:'none', color:'#fff'}}>Proceed</button>
                   </div>
                   </Form>
                  </div>
                  </Col>
                  <Col className='' >
                  <div style={{border:'1px solid #99A1A1'}}>
                  <div className='p-3 d-flex flex-column gap-2' style= {{ fontSize:'16px', fontWeight:'600'}}>
                   <p style={{fontSize:'16px', fontWeight:'500'}}>Payment Details</p>
                   <div className='d-flex justify-content-between p-0 p-lg-1' style={{border:'1px solid #99A1A1'}}>
                    <p>{carBrand}</p>
                    <p>NGN {amount.toLocaleString()}</p>
                   </div>
                   
                   <div className='d-flex justify-content-between'>
                    <p>VAT</p>
                    <p>NGN {vatAmount.toLocaleString()}</p>
                   </div>
                   <div className='line' style={{width:'100%'}}></div>
                   <div className='d-flex justify-content-between'>
                    <p>Total</p>
                    <p style={{fontSize:"16px"}}>NGN {totalAmount.toLocaleString()}</p>
                   </div>
                  </div>
                  </div>
                  </Col>
                  </Row>
                </div>
              )}
               {selectedButton === 2 &&(
                 <div>
                 <Row  className='mt-3 gap-5' style={{color:'#283333'}}>
               <Col xs={12} md={6}  style={{border:'1px solid #99A1A1'}}>
               <div className='d-flex flex-column gap-3 p-3'>
                 <Form onSubmit={() => handleButtonClick(3)}>
                  <Form.Group className='d-flex gap-2 mb-3'>
                    <Form.Label style={{width:'175px'}}>Title</Form.Label>
                  <Form.Select className='' value={title}  onChange={handleTitleChange} isValid={title!== ''}
            isInvalid={title=== ''}>
                       
                       <option value="">Select </option>
          <option value="mr">Mr.</option>
          <option value="mrs.">Mrs.</option>
          <option value="miss">Miss</option>
  
                      </Form.Select>
                  </Form.Group>
                   <Form.Group className='d-flex gap-2 mb-3'>
                     <Form.Label style={{width:'175px'}}>First Name</Form.Label>
                     <Form.Control type="text" placeholder="" value={firstName} onChange={handleFirstNameChange}
        isValid={firstName !== ''}
       isInvalid={firstName === ''}/>
    
                   </Form.Group>
                   <Form.Group className='d-flex gap-2 mb-3'>
                     <Form.Label style={{width:'175px'}}>Last Name</Form.Label>
                     <Form.Control type="text" placeholder="" value={lastName} onChange={handleLastNameChange}
        isValid={lastName !== ''}
       isInvalid={lastName === ''}/>
    
                   </Form.Group>
                  
                   <Form.Group className='d-flex gap-2 mb-3'>
                     <Form.Label style={{width:'175px'}}>Mobile Number</Form.Label>
                     <Form.Control type="text" placeholder="" value={phoneNumber} onChange={handlePhoneNumberChange}
        isValid={phoneNumber !== ''}
       isInvalid={phoneNumber === ''}/>
    
                   </Form.Group>
                   
                
                   <Form.Group className='d-flex gap-2 mb-3'>
                     <Form.Label style={{width:'175px'}}>Nationality</Form.Label>
                     <Form.Control type="text" placeholder="" value={nationality} onChange={handleNationalityChange}
        isValid={nationality !== ''}
       isInvalid={nationality === ''}/>
    
                   </Form.Group>
                 
                <div className='text-center'>
                 <button disabled={!isForm2Valid}  style={{height: '48px',
width: '200px',

borderRadius: '8px',

backgroundColor: '#008080', border:'none', color:'#fff'}}>Proceed</button>
                </div>
                </Form>
               </div>
               </Col>
               <Col className='' >
               <div style={{border:'1px solid #99A1A1'}}>
               <div className='p-3 d-flex flex-column gap-2' style= {{ fontSize:'16px', fontWeight:'600'}}>
                <p style={{fontSize:'16px', fontWeight:'500'}}>Payment Details</p>
                <div className='d-flex justify-content-between p-0 p-lg-1' style={{border:'1px solid #99A1A1'}}>
                 <p>{carBrand}</p>
                 <p>NGN {amount.toLocaleString()}</p>
                </div>
               
                <div className='d-flex justify-content-between'>
                 <p>VAT</p>
                 <p>NGN {vatAmount.toLocaleString()}</p>
                </div>
                <div className='line' style={{width:'100%'}}></div>
                <div className='d-flex justify-content-between'>
                 <p>Total</p>
                 <p style={{fontSize:"16px"}}>NGN {totalAmount.toLocaleString()}</p>
                </div>
               </div>
               </div>
               </Col>
               </Row>
             </div>
              )}
               {selectedButton === 3 &&(
               <div>
               <Row  className='mt-3 gap-5' style={{color:'#283333'}}>
             <Col xs={12} md={6}  style={{border:'1px solid #99A1A1'}}>
             <div className='d-flex flex-column gap-3 p-2 p-md-3 p-lg-5'>
               <Form onSubmit={handleModalShow}>

                <div  style={{border:'1px solid #99A1A1', width:'auto'}} className='d-flex gap-3 mb-5 justify-content-center'>
               <img src={masterCard} alt='card' style={{width:'70px', height:'70px'}}/>
               <img src={visa} alt='card' style={{width:'70px', height:'70px'}}/>
               <img src={discover} alt='card' style={{width:'70px', height:'70px'}}/>
                </div>
                 <Form.Group className='mb-4'>
                   <Form.Label className='mb-1'>Card Name</Form.Label>
                   <Form.Control type="text" placeholder="" value={cardName} onChange={handleCardNameChange}
      isValid={cardName !== ''}
     isInvalid={cardName === ''}/>
   
                 </Form.Group>
                 <Form.Group className='mb-4'>
                   <Form.Label className='mb-1'>Card Details</Form.Label>
                   <Form.Control type="text" placeholder="" value={cardDetails} onChange={handleCardDetailsChange}
      isValid={cardDetails !== ''}
     isInvalid={cardDetails === ''}/>
   
                 </Form.Group>
                 <div className='d-flex justify-content-between'>
                 <Form.Group className='mb-4'>
                   <Form.Label className='mb-1'>Expiry Date</Form.Label>
                   <Form.Control type="date" placeholder="" value={expiryDate} onChange={handleExpiryDateChange}
      isValid={expiryDate !== ''}
     isInvalid={expiryDate === ''}/>
   
                 </Form.Group>
                 <Form.Group className='mb-4'>
                   <Form.Label className='mb-1'>CVV2</Form.Label>
                   <Form.Control type="text" placeholder="" value={cvvNumber} onChange={handleCvvNumberChange}
      isValid={cvvNumber !== ''}
     isInvalid={cvvNumber === ''}/>
   
                 </Form.Group>
                 </div>
                 <Form.Group className='mb-5'>
                   <Form.Label className='mb-1'>Add Coupon</Form.Label>
                   <Form.Control type="text" placeholder="" value={coupon} onChange={handleCouponChange}
     />
   
                 </Form.Group>
              <div className='text-center'>
               <button disabled={!isForm3Valid}  style={{height: '48px',
width: '200px',

borderRadius: '8px',

backgroundColor: '#008080', border:'none', color:'#fff'}}>Make Payment</button>

              </div>
              <CarPaymentModal show={modalShow}
                
                 />
              </Form>
             </div>
             </Col>
             <Col className='' >
             <div style={{border:'1px solid #99A1A1'}}>
             <div className='p-3 d-flex flex-column gap-2' style= {{ fontSize:'16px', fontWeight:'600'}}>
              <p style={{fontSize:'16px', fontWeight:'500'}}>Payment Details</p>
              <div className='d-flex justify-content-between p-0 p-lg-1' style={{border:'1px solid #99A1A1'}}>
               <p>{carBrand}</p>
               <p>NGN {amount.toLocaleString()}</p>
              </div>
             
              <div className='d-flex justify-content-between'>
               <p>VAT</p>
               <p>NGN {vatAmount.toLocaleString()}</p>
              </div>
              <div className='line' style={{width:'100%'}}></div>
              <div className='d-flex justify-content-between'>
               <p>Total</p>
               <p style={{fontSize:"16px"}}>NGN {totalAmount.toLocaleString()}</p>
              </div>
             </div>
             </div>
             </Col>
             </Row>
           </div>
              )}
            </div>
          </div>
    </Container>
  )
}

export default CarItinerary
